$( ".quick-add__submit" ).click( function() {
  // Get Associated Modal ID
  var modalIdStripped;
  var modalId = $(this).parent().attr('data-modal');
  // Remove # from string
  modalIdStripped = modalId.replace('#', '');
  // Add ID as identifier on Swiper
  modalIdStripped = 'swiper-' + modalIdStripped;
  modalIdStripped = 'swiper-' + modalIdStripped;

  var mainSlider = 'main-' + modalIdStripped;
  var thumbsSlider = 'thumbs-' + modalIdStripped;

  setTimeout(function() {
    $(modalId).find('.mySwiper2').addClass(mainSlider);
    $(modalId).find('.swiper.small-hide').addClass(thumbsSlider);
  
    // Product Page Slider
    var swiper = new Swiper(".mySwiper", {
      // loop: true,
      spaceBetween: 10,
      slidesPerView: 'auto',
      freeMode: true,
      watchSlidesProgress: true,
      // centeredSlides: true,
      breakpoints: {
        0: {
          enabled: false
        },
        750: {
          slidesPerView: 'auto'
        },
        1050: {
          slidesPerView: 'auto'
        }
      }
    });
    var swiper2 = new Swiper(".mySwiper2", {
      loop: true,
      spaceBetween: 10,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      thumbs: {
        swiper: swiper
      },
      breakpoints: {
        // when window width is >= 0px
        0: {
          slidesPerView: 1
        },
        // when window width is >= 1250px
        990: {
          slidesPerView: 1
        }
      }
    });
  }, 1000);
});



// Add Dropdown Menu Hover Functionality
// let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
// items.forEach(item => {
//   item.addEventListener("mouseover", () => {
//     item.setAttribute("open", true);
//     item.querySelector("ul").addEventListener("mouseleave", () => {
//       item.removeAttribute("open");
//     });
//     item.addEventListener("mouseleave", () => {
//       item.removeAttribute("open");
//     });
//   });  
// });

// Hero Slider
// var heroSwiper = new Swiper(".hero-swiper", {
//   loop: true,
//   slidesPerView: 1,
//   speed: 600,
//   autoplay: {
//     delay: 4000,
//     disableOnInteraction: false,
//   },
//   pagination: {
//     el: ".swiper-pagination",
//     clickable: true,
//   }
// });

// Product Page Slider
var swiper = new Swiper(".mySwiper", {
  // loop: true,
  spaceBetween: 10,
  slidesPerView: 'auto',
  freeMode: true,
  watchSlidesProgress: true,
  // centeredSlides: true,
  breakpoints: {
    0: {
      enabled: false
    },
    750: {
      slidesPerView: 'auto'
    },
    1050: {
      slidesPerView: 'auto'
    }
  }
});
var swiper2 = new Swiper(".mySwiper2", {
  loop: true,
  spaceBetween: 10,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  },
  thumbs: {
    swiper: swiper
  },
  breakpoints: {
    // when window width is >= 0px
    0: {
      slidesPerView: 1
    },
    // when window width is >= 1250px
    990: {
      slidesPerView: 2
    }
  }
});
